export default {
  label: {
    switch_lang: 'Ubah bahasa ke:',
    no_resources_found: 'Tidak ada sumber daya yang ditemukan'
  },
  navbar: {
    logOut: 'Keluar',
    login: 'Masuk',
    signup: 'Daftar',
    documentation: 'Dokumentasi',
    console: 'Console'
  },
  breadcrumb: {
    back: 'Kembali'
  },
  sidebar: {
    privacy_policy: 'Kebijakan Privasi',
    information: 'Apa yang kami lakukan dengan informasi Anda',
    security: 'Keamanan',
    disclosure: 'Pengungkapan',
    cookies: 'Cookies',
    google_analytics: 'Google Analytics dan Pemasaran',
    changes_privacy: 'Perubahan Terhadap Kebijakan Privasi',
    data_deletion: 'Penghapusan Data'
  },
  login: {
    title: 'Masuk',
    email: 'Email',
    password: 'Password',
    forgotpass: 'Lupa Password',
    dont_have_account: 'Belum punya akun?',
    clickhere: 'Klik disini',
    signin: 'Masuk',
    verified: 'Akun terverifikasi',
    verified_message: 'Selamat! akun Olsera Open Platform Anda telah diverifikasi.',
    not_verified: 'Akun belum terverifikasi',
    explore_now: 'Jelajahi sekarang'
  },
  login_olsera: {
    title: 'Masuk ke Akun Olsera',
    description: 'profil kamu harus diperbarui sebelum Anda dapat membuat aplikasi baru',
    button_loggin_account: 'Masuk ke Akun Olsera',
    button_loggin: 'Masuk',
    login_success: 'Berhasil Login'
  },
  forgot: {
    title: 'Lupa Password',
    email: 'Email',
    signin: 'Masuk',
    backtopage: 'Kembali ke halaman?',
    description: 'Silahkan ketik alamat email yang terdaftar di Olsera. Kami akan mengirimkan petunjuk untuk memulihkan password Anda.',
    send: 'Kirim',
    forgot_success: 'Tautan sukses terkirim ke email',
    forgot_failed: 'Tautan gagal terkirim ke email'
  },
  reset: {
    title: 'Atur Ulang Password',
    new_password: 'Password Baru',
    c_new_password: 'Konfirmasi Password Baru',
    button_reset: 'Atur Ulang',
    reset_success: 'Password telah berhasil diperbarui'
  },
  register: {
    title: 'Daftar',
    name: 'Nama',
    email: 'Email',
    password: 'Password',
    c_password: 'Konfirmasi Password Baru',
    have_account: 'Sudah punya akun?',
    clickhere: 'Klik disini',
    sginup: 'Daftar',
    resend: 'Kirim Ulang',
    description1: 'Dengan mendaftar Anda telah menyetujui',
    description2: 'dan telah membaca serta memahami',
    term_condition: 'Syarat dan Ketentuan',
    privacy_policy: 'Kebijakan Privasi',
    message: 'Silakan periksa email Anda dan klik tautan verifikasi dalam waktu 24 jam untuk menyelesaikan pendaftaran Anda.',
    verification_email: 'Verifikasi Email',
    verification_sent: 'Email konfirmasi telah dikirim ke',
    no_verification_email: 'Tidak menerima email verifikasi?'
  },
  verification: {
    verified: 'Tautan verifikasi berhasil dikirim ke email',
    no_verified: 'Tautan verifikasi gagal dikirim ke email'
  },
  landing_page: {
    helping_merchants: 'Membantu Merchants',
    to_open: 'Untuk Membuka',
    new_opportunities: 'Peluang Baru',
    button_get_access: 'Dapatkan Akses Sekarang',
    about_olsera: 'Tentang Olsera',
    about_detail: 'Olsera adalah Aplikasi Kasir Premium yang jauh lebih mudah, dengan jangkauan yang semakin luas dan pertumbuhan bisnis yang semakin pesat.',
    features: {
      title: 'Fitur & Manfaat Utama Platform Olsera',
      open_api: 'Open API',
      open_api_desc: 'Menawarkan berbagai macam API yang mencakup fungsionalitas inti bisnis e-niaga.',
      technical_support: 'Technical Support',
      technical_support_desc: 'Dukungan teknis khusus untuk memberikan pengalaman pelanggan yang luar biasa.',
      testing_account: 'Testing Account & Tools',
      testing_account_desc: 'Mempercepat proses pengembangan dengan menguji akun dan alat.',
      service_market: 'Service Market',
      service_market_desc: 'Perluas cakupan layanan dan tingkatkan peluang bisnis.'
    },
    join_open_api: 'Bergabunglah dengan Open Platform Olsera',
    description: 'Melayani jutaan penjual dan buka peluang tak terbatas'
  },
  privacy_policy: {
    title: 'Kebijakan Privasi',
    description: 'Olsera mengumpulkan alamat e-mail dari orang yang mengirimkan e-mail. Kami juga mengumpulkan informasi tentang apa akses halaman pengguna dan informasi yang diberikan kepada kami oleh pengguna melalui survei dan pendaftaran situs. Informasi tersebut mungkin berisi data pribadi tentang Anda termasuk alamat Anda, nomor telepon, nomor kartu kredit dll. Olsera melindungi informasi kartu kredit sesuai dengan standar keamanan. Kami tidak diperbolehkan untuk mengungkapkan informasi pribadi tanpa izin tertulis dari Anda. Namun, informasi tertentu yang dikumpulkan dari Anda dan tentang Anda digunakan dalam konteks menyediakan layanan kami kepada Anda. Informasi yang kami kumpulkan tidak dibagi dengan, dijual atau disewakan kepada orang lain, kecuali dalam keadaan tertentu dan yang penggunaan Layanan tersebut dianggap telah mendapatkan persetujuan yang valid untuk mengungkapkan hal-hal berikut:',
    privacy1: 'Olsera dapat berbagi informasi pribadi dalam rangka untuk menyelidiki, mencegah, atau mengambil tindakan terkait dengan aktivitas ilegal, dugaan penipuan, situasi yang melibatkan kemungkinan ancaman terhadap keselamatan fisik seseorang, pelanggaran istilah Olsera penggunaan, atau sebagaimana diharuskan oleh hukum.',
    privacy2: 'Olsera mempekerjakan perusahaan lain untuk melakukan tugas-tugas atas nama kami dan mungkin perlu untuk berbagi informasi Anda dengan mereka untuk menyediakan produk dan layanan kepada Anda.',
    privacy3: 'Kami akan mentransfer informasi tentang Anda jika Olsera dipindahtangankan kepada perusahaan lain. Dalam hal ini, Olsera akan memberitahu Anda melalui email atau dengan meletakkan pemberitahuan yang jelas di situs web Olsera sebelum informasi tentang Anda yang sudah ditransfer menjadi tunduk pada kebijakan privasi yang berbeda.'
  },
  information: {
    title: 'Apa yang kami lakukan dengan informasi Anda'
  },
  security: {
    title: 'Keamanan',
    description: 'Keamanan informasi pribadi Anda adalah sangat penting bagi kami. Bila Anda memasukkan informasi sensitif, seperti nomor kartu kredit di formulir pendaftaran kami, kami mengenkripsi transmisi informasi menggunakan teknologi socket layer yang aman (SSL), namun tidak ada yang bersifat 100% terlebih cara Anda menggunakan informasi Anda akan sangat berpengaruh. Sementara kami berusaha untuk menggunakan cara-cara yang dapat diterima secara komersial untuk melindungi informasi pribadi Anda, kami tidak dapat menjamin keamanan mutlak. Jika Anda memiliki pertanyaan tentang keamanan di situs Web kami, Anda dapat email kami di',
    email: '{account}{\'@\'}{domain}'
  },
  disclosure: {
    title: 'Pengungkapan',
    description1: 'Olsera dapat menggunakan penyedia layanan pihak ketiga untuk menyediakan layanan tertentu kepada Anda dan kami dapat berbagi informasi pribadi dengan penyedia layanan tersebut. Kami memerlukan perusahaan yang dapat berbagi informasi pribadi untuk melindungi data yang secara konsisten dengan kebijakan ini dan untuk membatasi penggunaan informasi pribadi tersebut kepada kinerja pelayanan untuk Olsera. Olsera dapat mengungkapkan informasi pribadi dalam situasi khusus, seperti untuk mematuhi perintah pengadilan mengharuskan kami untuk melakukannya atau ketika tindakan Anda melanggar Ketentuan Layanan.',
    description2: 'Kami tidak menjual atau memberikan informasi pribadi kepada perusahaan lain untuk memasarkan produk atau jasa mereka sendiri.'
  },
  cookies: {
    title: 'Cookies',
    description: 'Olsera dapat menggunakan penyedia layanan pihak ketiga untuk menyediakan layanan tertentu kepada Anda dan kami dapat berbagi informasi pribadi dengan penyedia layanan tersebut. Kami memerlukan perusahaan yang dapat berbagi informasi pribadi untuk melindungi data yang secara konsisten dengan kebijakan ini dan untuk membatasi penggunaan informasi pribadi tersebut kepada kinerja pelayanan untuk Olsera. Olsera dapat mengungkapkan informasi pribadi dalam situasi khusus, seperti untuk mematuhi perintah pengadilan mengharuskan kami untuk melakukannya atau ketika tindakan Anda melanggar Ketentuan Layanan. Kami tidak menjual atau memberikan informasi pribadi kepada perusahaan lain untuk memasarkan produk atau jasa mereka sendiri.'
  },
  google_analytics: {
    title: 'Google Analytics dan Pemasaran',
    description: 'Kami menggunakan layanan yang disediakan oleh Google yang disebut Google Analytics (GA). GA memungkinkan kami untuk menjangkau orang-orang yang sebelumnya telah mengunjungi situs kami, dan menunjukkan kepada mereka iklan yang relevan ketika mereka mengunjungi situs lain di Internet dalam Jaringan Display Google. Cookie dapat digunakan untuk melacak sesi Anda di website kami, untuk melayani iklan disesuaikan dari Google dan vendor pihak ketiga lainnya. Ketika Anda mengunjungi situs ini, Anda mungkin melihat iklan yang diposting di situs oleh Google atau pihak ketiga lainnya. Melalui pihak pertama dan cookie pihak ketiga, pihak ketiga tersebut dapat mengumpulkan informasi tentang Anda ketika Anda mengunjungi situs ini dan situs-situs lain. Mereka mungkin menggunakan data ini untuk menampilkan iklan di situs ini dan di Internet berdasarkan kunjungan Anda sebelum website ini dan di tempat lain di Internet. Kami tidak mengumpulkan informasi ini atau mengontrol isi dari iklan yang akan Anda lihat. Anda mungkin dapat memilih keluar dari iklan Jaringan Display Google disesuaikan dengan mengunjungi Preferensi Iklan (http://www.google.com/ads/preferences/), dan Google Analytics Opt-out Browser Add-on (http: //www.google.ca/ads/preferences/plugin/). Penggunaan Anda atas situs ini tanpa memilih keluar berarti bahwa Anda memahami dan menyetujui pengumpulan data untuk menyediakan Anda dengan pemasaran ulang iklan menggunakan GA dan cookie dari vendor pihak ketiga lainnya berdasarkan kunjungan Anda sebelum website ini dan di tempat lain di Internet.'
  },
  changes_privacy: {
    title: 'Perubahan Terhadap Kebijakan Privasi',
    description: 'We reserve the right to change this privacy statement at any time, so you are advised to review the changes as often as possible. If we make material changes to this policy, we will notify you here or by means of a notification on our homepage so that you are aware of what information we collect and how we use it.'
  },
  data_deletion: {
    title: 'Penghapusan Data',
    description: 'Pelanggan dapat mengajukan permintaan penghapusan data di server melalui email ke',
    email: '{account}{\'@\'}{domain}'
  },
  introduction_page: {
    intro_title: 'Pengantar',
    production: '(Production)',
    language: 'Bahasa',
    example: 'Contoh',
    api_url: 'https://api-open.all.olsera.indociti.com',
    console_app: 'console -> app list',
    intro_desc1: 'Olsera menyediakan API yang dapat digunakan untuk mengintegrasikan sistem Anda dengan platform kami.',
    intro_desc2: 'API dibangun berdasarkan konsep REST, dan akan mengembalikan data berformat JSON atas permintaan Anda.',
    intro_desc3: 'Platform Terbuka Olsera dapat menyediakan fungsi berikut empat mitra kami:',
    global_list: 'Daftar Global',
    customer_list: 'Daftar Pelanggan & Pemasok',
    product_list: 'Product List',
    order_management: 'Management Order',
    purchase: 'Pembelian',
    intro_desc4_a: 'Untuk mengakses api kami, klien harus mendaftarkan akun olsera-nya di',
    intro_desc4_b: 'nanti sistem akan menghasilkan app_id dan secret_key.',
    intro_desc5: 'app_id digunakan sebagai pengidentifikasi unique untuk akun anda beserta digunakan untuk memperoleh access_token, access_token dugunakan untuk mengakses enpoint api olsera, sedangkan secret key digunakaan untuk mengenkripsi data pada saat request access_token',
    intro_desc6: 'Mendapatkan access_token dan refresh token by api sebagai berikut:',
    intro_desc7: 'Anda perlu mengenkripsi data menggunakan hash_hmac(\'sha256\', $data, secret_key) $data didasarkan pada (app_id:timestamp) sebagai berikut:',
    intro_desc8_list1_a: 'Buat permintaan POST ke',
    intro_desc8_list1_b: 'berikut contoh nya:',
    intro_desc8_list2: 'Jika berhasil, Anda akan menerima access_token dan refresh_token. Saat token akses kedaluwarsa, Anda harus meminta token baru menggunakan refresh_token, contoh response nya:',
    intro_desc9: 'Kami juga menyediakan bahasa di API dengan pilihan bahasa Indonesia / Inggris yang dapat diimplementasikan, Anda dapat mengubah bahasa dengan menambahkan opsi path localization => [en / id] ke semua endpoints',
    quick_start_title: 'Mulai Cepat',
    quick_start_desc1: 'Anda dapat mencoba semua API yang kami sediakan dengan mudah dengan Postman. Unduh koleksi yang dibuat sebelumnya berdasarkan Olsera Open API.',
    quick_start_desc2: 'Untuk penjelasan lebih lanjut tentang cara menggunakan koleksi ini di Postman, silakan lompat ke Bab Pengujian.',
    api_reference: 'referensi disini'
  },
  app_list: {
    title: 'List Aplikasi',
    btn_create: 'Buat Aplikasi'
  },
  store_list: {
    title: 'Daftar Toko',
    btn_create: 'Buat',
    submit_success: 'Berhasil Submit'
  },
  developer_guide: {
    overall_procedure: 'Prosedur Keseluruhan',
    step1: {
      title: 'Langkah 1: Daftarkan Platform Olsera',
      step1_a: 'a. Daftar ke Platform Olsera, kirimkan email dan kata sandi Anda',
      step1_b: 'b. Kami akan mengirimkan email verifikasi, jika masih belum ada email dari kami pilih kirim ulang',
      step1_c: 'c. Klik "Verify Your Email"',
      step1_d: 'd. Akun telah terverifikasi',
      step1_e: 'e. Anda juga akan mendapatkan email akun berhasil dibuat, klik "Get Started"',
      step1_f: 'f. Login menggunakan email dan password yang telah terverifikasi',
      step1_g: 'g. Jika suatu waktu Anda lupa password, pergi ke halaman "Lupa Password" kirimkan email terdaftar',
      step1_h: 'h. Klik "Reset Password"',
      step1_i: 'i. Masukan password baru dan konfirmasi password baru Anda lalu klik "Atur Ulang"'
    },
    step2: {
      title: 'Langkah 2: Buat App',
      step2_a: 'a. Klik "Login to Olsera Account" dan akan diarahkan ke halaman berikutnya',
      step2_b: 'b. Kirim alamat email dan kata sandi Anda untuk login',
      step2_c: 'c. Login berhasil, Anda akan diarahkan ke halaman daftar toko',
      step2_d: 'd. Pilih toko, dan klik "Next" untuk membuat aplikasi toko Anda',
      step2_e: 'e. Masukan data yang diperlukan, lalu klik "Buat Aplikasi"',
      step2_f: 'f. Aplikasi berhasil dibuat, Klik salah satu untuk melihat detail',
      step2_g: 'g. Pada bagian detail ditampilkan "App ID" dan "Secret_key" beserta informasi lainnya',
      step2_h: 'h. Pada bagian "Kunci Aplikasi" Klik "Dapatkan Token" untuk mendapatkan akses token, lalu klik "Salin"',
      step2_i: 'i. Beralih ke menu "Dokumentasi" lalu pilih salah satu collection dan klik "Api Test Tool"',
      step2_j: 'j. Pada bagian "Request Parameters" masukan data yang diperlukan, lalu pada bagian "Headers" masukan "Token" yg diperoleh seblumnya, lalu klik "Send Request" untuk melihat hasil',
      step2_k: 'k. Klik "Edit App" untuk mengubah informasi aplikasi',
      step2_l: 'l. Klik "Hapus Aplikasi" untuk menghapus aplikasi'
    }
  },
  app_create: {
    btn_create: 'Buat Aplikasi'
  },
  app_detail: {
    basic_information: 'Informasi Dasar',
    app_key: 'Kunci Aplikasi',
    get_token: 'Dapatkan Token',
    copy: 'Salin'
  },
  app_edit: {
    select_file: 'Pilih File',
    choose_file_type: 'Pilih file atau letakkan di sini untuk mengunggah',
    change_logo: 'Ganti Logo',
    delete_confirm_app: 'Apakah Anda yakin untuk menghapus Aplikasi ini?',
    delete_confirm_logo: 'Apakah Anda yakin untuk menghapus gambar ini?',
    cancel_confirm: 'Tutup',
    accept_confirm: 'Ya',
    delete: 'Hapus',
    btn_delete_app: 'Hapus Aplikasi',
    btn_cancel: 'Batal',
    btn_save: 'Simpan',
    verified_callback_url: 'Terverifikasi, harap simpan URL panggilan balik dan buka pengaturan push untuk penggunaan lanjutan.',
    not_verified_callback_url: 'Tidak terverifikasi, URL panggilan balik tidak ditemukan.',
    app_updated: 'Detail Aplikasi telah diperbarui!',
    app_deleted: 'Aplikasi telah dihapus!'
  },
  warning: {
    complete_the_data: 'Silakan Lengkapi data'
  },
  api_tool: {
    title: 'API Test Tool',
    send_request: 'Send Request'
  },
  webhook: {
    wb_setting: 'Pengaturan Webhook',
    wb_edit: 'Edit Webhook',
    wb_log: 'Request log',
    wb_open: 'Buka Pengaturan',
    wb_add_more: 'Tambah header',
    wb_save: 'Simpan',
    wb_close: 'Batal',
    cb_not_set: 'URL Callback belum disetel',
    cb_success: 'URL Callback berhasil disimpan',
    cb_failed: 'URL Callback gagal disimpan',
    save_success: 'Berhasil disimpan',
    save_failed: 'Gagal disimpan',
    message_success: 'URL Callback berhasil disimpan.',
    message_failed: 'URL Callback gagal disimpan karena terjadi kesalahan.',
    no_data: 'Tidak ada data'
  }
}
